import { render } from "./DialogBox.vue?vue&type=template&id=70ead4d0"
import script from "./DialogBox.vue?vue&type=script&lang=js"
export * from "./DialogBox.vue?vue&type=script&lang=js"

import "./DialogBox.vue?vue&type=style&index=0&id=70ead4d0&lang=scss"

import exportComponent from "/Users/william/Documents/beadographer3/bead3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__